import { render, staticRenderFns } from "./ColorGroup.vue?vue&type=template&id=06e1bd82"
import script from "./ColorGroup.vue?vue&type=script&lang=js"
export * from "./ColorGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports